export enum Permission {
  // Campaign
  CAMPAIGN_CREATE = 'campaign.create',
  CAMPAIGN_READ = 'campaign.read',
  CAMPAIGN_UPDATE = 'campaign.update',
  CAMPAIGN_DELETE = 'campaign.delete',
  CAMPAIGN_TOGGLE = 'campaign.toggle',
  CAMPAIGN_LOGIN_TO_CAMPAIGN = 'campaign.login_to_campaign',
  // Admin management
  ADMIN_MANAGEMENT_CREATE = 'admin_management.create',
  ADMIN_MANAGEMENT_READ = 'admin_management.read',
  ADMIN_MANAGEMENT_UPDATE = 'admin_management.update',
  ADMIN_MANAGEMENT_DELETE = 'admin_management.delete',
}

export const PIC_DEFAULT_PERMISSION = [
  Permission.CAMPAIGN_READ,
  Permission.CAMPAIGN_CREATE,
  Permission.CAMPAIGN_UPDATE,
];
